import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";
import NProgress from "nprogress";

Vue.use(VueRouter);

const BASE = process.env.VUE_APP_BASE_PATH || "/";

const router = new VueRouter({
  mode: "history",
  base: BASE || "/",
  routes: routes,
});

router.beforeEach((to, from, next) => {
  store.commit("isLoading", true);
  NProgress.start();

  if (to.meta.requiresAuth) {
    if (store.state.query.connected) next();
    else next({ name: "login" });
  } else {
    if (to.name === "login" && store.state.query.connected)
      next({ name: "servers" });
    else next();
  }
});

router.afterEach(() => {
  store.commit("isLoading", false);

  setTimeout(() => {
    if (store.state.query.loading) NProgress.inc();
    else NProgress.done();
  }, 0);
});

export default router;
